import React from "react";
import {MedicalOrganizationForm} from "../MedicalOrganizationForm";
import {MedicalOrganizationVaccine} from "../../../../types/MedicalOrganizationVaccine";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum MEDICAL_ORGANIZATION_MODAL_CONTENT {
  LOADING = 'loading',
  FORM = 'form',
  DELETE = 'delete',
}

interface MedicalOrganizationModalContentProps {
  formMode: 'edit' | 'add';
  editingMedicalOrganizationVaccine: MedicalOrganizationVaccine;
  onChangeEditingMedicalOrganization: (medicalOrganizationVaccine: MedicalOrganizationVaccine) => void;
  onClickSaveEdit: () => void;
  onClickDontDelete: () => void;
  onClickConfirmDelete: () => void;
}

export const MedicalOrganizationModalContent = ({
  formMode,
  editingMedicalOrganizationVaccine,
  onChangeEditingMedicalOrganization,
  onClickSaveEdit,
  onClickDontDelete,
  onClickConfirmDelete,
}: MedicalOrganizationModalContentProps) => ({
  [MEDICAL_ORGANIZATION_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="儲存中..." />
  ),
  [MEDICAL_ORGANIZATION_MODAL_CONTENT.FORM]: (
    <MedicalOrganizationForm
      mode={formMode}
      medicalOrganizationVaccine={editingMedicalOrganizationVaccine}
      onChangeMedicalOrganization={onChangeEditingMedicalOrganization}
      onClickSave={onClickSaveEdit}
    />
  ),
  [MEDICAL_ORGANIZATION_MODAL_CONTENT.DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除此醫療機構嗎？\n此動作將無法復原"
      leftLabel="不刪除"
      leftOnClick={onClickDontDelete}
      rightLabel="刪除"
      rightOnClick={onClickConfirmDelete}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  )
});
